import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
// import { applicationOptions } from '@/helpers/options'

import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        online: true,
        data: {
            width: null,
            aspectRatio: null,
            diameter: null,
            loadIndex: null,
            axleWeight: null,
            type: 'R-1',
            application: '',
            quantity: 1,
        },
    },
    mutations,
    getters,
    actions: {
    }
})

store.watch(
    (state, getters) => getters.typeBase,
    (value) => {
        const options = _.map(store.getters.applicationOptionsAvailable, 'value')
        if (_.includes(options, store.state.data.application)) {
            return
        }

        store.commit('updateData', { application: null })
    }
)

export default store
